import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-index-case-study',
  standalone: false,
  templateUrl: './index-case-study.component.html',
  styleUrl: './index-case-study.component.scss'
})
export class IndexCaseStudyComponent {
  private authService = inject(AuthService);


  showVideo: boolean = false;

  constructor() { }

  async signIn() {
    await this.authService.login();
  }
}
